<template>
    <span class="sector" v-if="sector">{{ sector.name }}</span>
</template>

<script>
	import { mapState } from 'vuex';

	export default {
		name: 'ColumnSector',
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
		},
		computed: {
			...mapState({
				user: state => state.auth.user,
			}),
			sector() {
                if(this.rowData.primarySector) {
                    return this.rowData.primarySector;
                }

				if(!this.rowData.sectors || !this.rowData.sectors.length) {
					return '';
				}

				if(!this.user.subscribed || !this.user.subscribed.length) {
					return this.rowData.sectors[0];
				}

				//Filter row sectors to ones the user is subscribed to
				let subscribed = this.user.subscribed.map(sector => sector.id),
					sectors = this.rowData.sectors.filter(sector => subscribed.indexOf(sector.id) > -1);

				//Return first subscribed sector, or first row sector if none are subscribed to
				return sectors.length ? sectors[0] : this.rowData.sectors[0];
			},
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
